const getInitialState = () => ({
    startTime: '',
    endTime: '',
    errorArray: [],
    isRunning: false,
    numberOfAttempts: [],
    numberOfChars: 0,
    numberOfNonLetters: 0,
    responseData: []
});
export default getInitialState;
